import React from "react";
import '../styles/welcome.css';
import { apiIsLoggedIn, apiWelcome } from "../api/api";
import LoginForm from "../components/forms/LoginForm";
import CreateAccountButton from "../components/buttons/CreateAccountButton";

class Welcome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            welcomeString: '',
            loggedIn: false,
        };
    }

    componentDidMount() {
        this.props.strings.then(data => {
            this.setState({
                ...this.state,
                welcomeString: data.welcome.EN,
            });
        });
        apiIsLoggedIn().then(isLoggedIn => {
            this.setState({
                ...this.state,
                loggedIn: isLoggedIn,
            });
        });
    }

    render() {
        return (
          <div className="welcome">
            <h2>Welcome!</h2>
            {this.state.loggedIn ? (
                window.location.href = '/landing'
            ) : (
            <p>
                {this.state.welcomeString}
                <LoginForm />
                <CreateAccountButton />
            </p>
            )}
          </div>
        );
    }
}

export default Welcome;
